import { useTranslation } from 'react-i18next';

import clsx from 'clsx';

import Out1Image from '@/assets/out-cli1.png';
import OutCliBg from '@/assets/out-cli-bg.png';
import TerminalIcon from '@/assets/terminal-icon.svg?react';

import css from './index.module.less';

export function SPECModeSection() {
  const { t } = useTranslation();

  return (
    <div className={clsx(css['plan-mode-section'], 'flex flex-col lg:flex-row')}>
      <div className={clsx(css['content-left'])}>
        <TerminalIcon className={clsx(css['terminal-icon'])} />
        <h3 className={clsx(css['title'])}>{t('cli.specMode.title')}</h3>
        <div className={clsx(css['description'])}>{t('cli.specMode.description')}</div>
      </div>
      <div
        className={clsx(css['content-right'])}
        style={{
          backgroundImage: `url(${OutCliBg})`,
          backgroundSize: 'cover',
        }}
      >
        <img src={Out1Image} alt="终端" className={clsx(css['image'])} />
      </div>
    </div>
  );
}
